<template>
  <div class="markdown prose w-full break-words dark:prose-invert light container">
    <hr>
    <h1 style="text-align: center">QUY ĐỊNH SỬ DỤNG DỊCH VỤ CHO ỨNG DỤNG HÀNH CHÍNH SỐ</h1>
    <h2>1. Chấp Nhận Điều Khoản</h2>
    <p>Việc sử dụng ứng dụng hành chính số của Trường Đại học Đồng Tháp (sau đây gọi là "D-Office") phải tuân theo các
      điều khoản và điều kiện được mô tả trong Quy định Sử dụng Dịch vụ này. Khi bạn truy cập hoặc sử dụng ứng dụng, bạn
      đã chấp nhận và đồng ý tuân thủ các điều khoản này.</p>
    <h2>2. Sử Dụng Dịch Vụ</h2>
    <h3>2.1. Tuân Thủ Luật Pháp</h3>
    <ul>
      <li>Bạn phải tuân thủ tất cả các luật pháp và quy định áp dụng khi sử dụng ứng dụng.</li>
      <li>Bạn không được sử dụng ứng dụng cho bất kỳ mục đích bất hợp pháp nào.</li>
    </ul>
    <h3>2.2. Bảo Mật</h3>
    <ul>
      <li>Bạn phải bảo mật thông tin đăng nhập và không chia sẻ tài khoản của bạn với người khác.</li>
      <li>Bạn phải báo cáo ngay lập tức bất kỳ việc sử dụng tài khoản của bạn mà bạn không nhận biết.</li>
    </ul>
    <h2>3. Thông Tin Cá Nhân</h2>
    <ul>
      <li>Chúng tôi sẽ thu thập và sử dụng thông tin cá nhân của bạn theo Chính sách Bảo mật của ứng dụng.</li>
    </ul>
    <h2>4. Nội Dung</h2>
    <ul>
      <li>Bạn chịu trách nhiệm về nội dung bạn đăng tải hoặc chia sẻ thông qua ứng dụng.</li>
      <li>Bạn không được đăng tải hoặc chia sẻ nội dung có thể xâm phạm quyền riêng tư, bản quyền hoặc các quyền khác
        của người khác.
      </li>
    </ul>
    <h2>5. Chấm Dứt Dịch Vụ</h2>
    <p>Chúng tôi có quyền chấm dứt hoặc tạm ngừng cung cấp dịch vụ của ứng dụng nếu bạn vi phạm bất kỳ điều khoản hoặc
      điều kiện nào được mô tả trong Quy định Sử dụng Dịch vụ này.</p>
    <h2>6. Sửa Đổi Quy Định</h2>
    <p>Chúng tôi có quyền sửa đổi Quy định Sử dụng Dịch vụ này theo thời gian và sẽ thông báo cho người dùng qua ứng
      dụng hoặc trang web của Trường Đại học Đồng Tháp.</p>
    <p>Quy định này có hiệu lực từ ngày 01/01/2023.</p>
    <hr>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
}
</script>

<style scoped>

</style>
